import Vue from 'vue';
import {AxiosPromise} from 'axios';
import {Location, DataTableRequest, Response} from '@/models';
// @ts-ignore
import FileSaver from 'file-saver';

class LocationService extends Vue {
  private ROOT_API = process.env.VUE_APP_ROOT_API + '/webapi/location';

  public getAll(request: DataTableRequest): AxiosPromise<Response<any>> {
    return Vue.axios.get<Response<any>>(this.ROOT_API + '/get-all/', {params: request});
  }
  public get(id: string): AxiosPromise<Response<Location>> {
    return Vue.axios.get<Response<Location>>(this.ROOT_API + '/' + id);
  }
  public update(data: Location): AxiosPromise<Response<any>> {
    return Vue.axios.put<Response<any>>(this.ROOT_API + '/update', data);
  }
  public create(data: Location): AxiosPromise<Response<Location>> {
    return Vue.axios.post<Response<Location>>(this.ROOT_API, data);
  }
  public delete(ids: string[]): AxiosPromise<Response<any>> {
    return Vue.axios.post(this.ROOT_API + "/delete", ids);
  }
  public checkExist(location: Location): AxiosPromise<Response<any>> {
    return Vue.axios.post(this.ROOT_API + "/check-exist", location);
  }
  public existByIds(ids: string[]): AxiosPromise<Response<any>> {
    return Vue.axios.post(this.ROOT_API + "/exist-by-ids", ids);
  }
  
}
export const locationService = new LocationService();
